import { message } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";

export const useReviewManagement = () => {
  const [reviews, setReviews] = useState([]);
  const [filteredReviews, setFilteredReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterRating, setFilterRating] = useState(null);

  useEffect(() => {
    fetchReviews();
  }, []);

  // Fetch all reviews from the server
  const fetchReviews = async () => {
    setLoading(true);
    try {
      const response = await axios.get("/api/rooms/getallreviews");
      setReviews(response.data.reviews);
      setFilteredReviews(response.data.reviews);
    } catch (error) {
      message.error("Error fetching reviews");
    } finally {
      setLoading(false);
    }
  };

  // Filter reviews by exact star rating
  const handleFilterByRating = (value) => {
    setFilterRating(value);
    const filtered = reviews.filter((review) => review.rating === value);
    setFilteredReviews(filtered);
  };

  // Filter reviews by keyword (in comment or bookingId)
  const handleSearch = (value) => {
    setSearchKeyword(value);
    const filtered = reviews.filter(
      (review) =>
        review.comment.toLowerCase().includes(value.toLowerCase()) ||
        review.bookingId.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredReviews(filtered);
  };

  // Reset all filters
  const resetFilters = () => {
    setFilteredReviews(reviews);
    setSearchKeyword("");
    setFilterRating(null);
  };

  // Delete a review
  const handleDeleteReview = async (roomId, reviewId) => {
    try {
      await axios.delete(`/api/rooms/deletereview/${roomId}/${reviewId}`);
      message.success("Review deleted successfully");
      fetchReviews();
    } catch (error) {
      message.error("Error deleting review");
    }
  };

  return {
    filteredReviews,
    loading,
    searchKeyword,
    filterRating,
    handleFilterByRating,
    handleSearch,
    resetFilters,
    handleDeleteReview,
    setSearchKeyword,
  };
};
